export default __webpack_public_path__ + "static/media/checked-circle-white.243d023d.svg";